import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 8,
		cy: 8,
		r: 8
	})
});
export default SvgCircle;
